import { message } from "antd";
import { useNavigate } from "react-router";
import { COMMONS } from "@/utils";

export const useScanErrorHandler = () => {
	const navigate = useNavigate();

	const handleScanError = (error: any) => {
		const responseData = error?.response?.data;
		// Handle both plain text and JSON response formats
		const errorMsg = typeof responseData === 'string' ? responseData : responseData?.message;
		if (
			error?.response?.status === 400 &&
			errorMsg === "INVALID_MEMBERSHIP"
		) {
			message.warning("有効な会員ではありません。");
		} else if (error?.response?.status === COMMONS.RESPONSE_CONFLICT_ERROR) {
			message.warning(COMMONS.WARN_MEMBER_CODE_NOT_EXIST_MSG);
		} else if (
			error?.response?.status === COMMONS.RESPONSE_PERMISSION_ERROR
		) {
			navigate(COMMONS.PERMISSION_ERROR_ROUTE);
		} else if (error?.response?.status === COMMONS.RESPONSE_SESSION_ERROR) {
			message.warning(COMMONS.ERROR_SESSION_MSG);
			navigate(COMMONS.ADMIN_LOGIN_ROUTE);
		} else if (error?.response?.status === COMMONS.RESPONSE_SYSTEM_ERROR) {
			message.error(COMMONS.ERROR_SYSTEM_MSG);
		} else {
			message.error(COMMONS.ERROR_SYSTEM_MSG);
		}
	};

	return { handleScanError };
};
